import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { CreditCardExaminationSearchRequest } from "../api-interfaces";

const initialState = {} as CreditCardExaminationSearchRequest;

const creditCardExaminationSearchConditionSlice = createSlice({
  name: "creditCardExaminationSearchCondition",
  initialState,
  reducers: {
    createSearchCondition: (
      state,
      action: PayloadAction<{
        orderTargetName: string;
        responseDateStart: string;
        responseDateEnd: string;
        applicationStatus: string;
        timestamp: number;
      }>
    ) => {
      const {
        orderTargetName,
        responseDateStart,
        responseDateEnd,
        applicationStatus,
        timestamp,
      } = action.payload;
      state.orderTargetName = orderTargetName;
      state.responseDateStart = responseDateStart;
      state.responseDateEnd = responseDateEnd;
      state.applicationStatus = applicationStatus;
      state.timestamp = timestamp;
    },
  },
});

export const { createSearchCondition } =
  creditCardExaminationSearchConditionSlice.actions;
export default creditCardExaminationSearchConditionSlice.reducer;
